var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScribbleDiagonalZigzag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.97 54.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.cls-2{stroke-dasharray:70.55 2.12;}.cls-3{stroke-dasharray:35.27 2.12 70.55 2.12;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.75,3.9S6.54,11.78,1.36,22.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.75,24.51A3,3,0,0,0,1,25.82c.47,1.05,1.58,1.86,4.24.08S20.47,12.82,42.29,1a2,2,0,0,1,2.54,3c-2.54,3.29-5.76,7.48-9.24,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.94,16.83c-5.32,7-11.18,14.65-16.09,21.19-7.17,9.53-8.52,11.19-6.05,14.64,3,4.18,12-2.55,12-2.55S47.26,35,69,22.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.88,22.26A222.31,222.31,0,0,1,92.22,11.07"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribbleDiagonalZigzag);
export default __webpack_public_path__ + "static/media/scribble-diagonal-zigzag.ecaaec1f6f5fc69fbf2152e7442302e9.svg";
export { ForwardRef as ReactComponent };